import { l as s } from "./lodash-5ofSKtz3.mjs";
import { e as t } from "./extract-rhf-validation-rule-value-DyB3XAHu.mjs";
function o(a, e = "") {
  return typeof a == "object" && a !== null && "message" in a && typeof a.message == "string" && !s.isEmpty(a.message) ? a.message : e;
}
function m(a, e = "") {
  return {
    message: o(a, e),
    value: t(a)
  };
}
export {
  m as a,
  o as e
};
//# sourceMappingURL=add-rhf-default-error-message-C9MkLfg3.mjs.map
